module.exports = __webpack_public_path__ + "static/media/salchiloca.d2277f40.jpeg";